import React from 'react';
import { Paper, Typography, Box, Grid, Divider } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const MVRReview = () => {
  // 模拟 MVR 数据
  const mvrData = {
    licenseInfo: {
      issueDate: '2020-06-15',
      birthDate: '1985-03-22',
      expiryDate: '2025-06-14'
    },
    violations: [
      {
        date: '2023-09-15',
        type: 'Speeding',
        description: 'Exceeding speed limit by 30km/h',
        points: 3,
        location: 'Highway 401, Toronto'
      },
      {
        date: '2023-05-22',
        type: 'Red Light',
        description: 'Failed to stop at red light',
        points: 3,
        location: 'Queen St & Bay St, Toronto'
      }
    ],
    suspensions: [
      {
        startDate: '2022-03-01',
        endDate: '2022-06-01',
        reason: 'Accumulated Demerit Points',
        details: 'License suspended for 3 months due to accumulation of 15 demerit points'
      },
      {
        startDate: '2021-01-15',
        endDate: '2021-02-15',
        reason: 'Unpaid Fines',
        details: 'Administrative suspension due to unpaid traffic violations'
      }
    ]
  };

  const InfoSection = ({ title, content }) => (
    <Box sx={{ mb: 1 }}>
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {content}
      </Typography>
    </Box>
  );

  const ViolationCard = ({ violation }) => (
    <Box sx={{ 
      p: 2, 
      mb: 2, 
      bgcolor: '#fff3e0', 
      borderRadius: 1,
      border: '1px solid #ffe0b2'
    }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Typography variant="subtitle2" color="warning.dark">
            Date: {violation.date}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Typography variant="subtitle2" color="warning.dark">
            Type: {violation.type}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            {violation.description}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            Location: {violation.location}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  const SuspensionCard = ({ suspension }) => (
    <Box sx={{ 
      p: 2, 
      mb: 2, 
      bgcolor: '#fbe9e7', 
      borderRadius: 1,
      border: '1px solid #ffccbc'
    }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="error.dark" sx={{ display: 'flex', alignItems: 'center' }}>
            <WarningIcon sx={{ mr: 1, fontSize: 20 }} />
            {suspension.reason}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2">
            Start Date: {suspension.startDate}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2">
            End Date: {suspension.endDate}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            {suspension.details}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 3, color: '#1565c0' }}>
        MVR Report Summary
      </Typography>

      <Grid container spacing={3}>
        {/* License Information */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            License Information
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <InfoSection 
                title="Issue Date"
                content={mvrData.licenseInfo.issueDate}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InfoSection 
                title="Birth Date"
                content={mvrData.licenseInfo.birthDate}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <InfoSection 
                title="Expiry Date"
                content={mvrData.licenseInfo.expiryDate}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 3 }} />
        </Grid>

        {/* Violations */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Traffic Violations
          </Typography>
          {mvrData.violations.map((violation, index) => (
            <ViolationCard key={index} violation={violation} />
          ))}
          <Divider sx={{ my: 3 }} />
        </Grid>

        {/* Suspensions */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            License Suspensions
          </Typography>
          {mvrData.suspensions.map((suspension, index) => (
            <SuspensionCard key={index} suspension={suspension} />
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MVRReview; 